import {ajax_post} from '../../public/global.js'
class currentUser {
    constructor () {
        this.user = {
            id: '',
            name: '',
            group:''
        }
    }
    setUser (token) {
        ajax_post(`/PHP/ajax/returnUser.php`, `token=${token}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
                this.user.id = rep.data.id
                this.user.group = rep.data.member
                this.user.name = rep.data.name
            }else{
                console.log("Benutzer konnte nicht aus dem Speicher abgerufen werden!")
            }
        })
      }

}
export default new currentUser()